import MuiInput, { InputProps } from '@mui/material/Input';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import styles from './Input.module.css';

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ value = '', inputRef, inputProps, ...props }, ref) => {
    return (
      <MuiInput
        {...props}
        inputRef={inputRef || ref}
        inputProps={inputProps}
        value={value}
        className={'MuiInputBase-formControl'}
        classes={{
          root: clsx(styles.root, props.classes?.root),
          input: clsx(styles.input, props.classes?.input),
          error: clsx(styles.error, props.classes?.error),
        }}
      />
    );
  },
);
